import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SiModalModule } from '../../si-modal';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './message-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SiModalModule,
    MatButtonModule,
  ],
})
export class MessageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: { message: string }) {
  }
}
